import React from 'react'
import { StoresContext } from '@App/contexts'
import { SelectOption } from '@Components/Selectors/Select'
import { observer } from 'mobx-react'
import { formatName } from '@App/helpers/format-name'
import { ZodFormattedError } from 'zod'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import { WriterModel } from '@Entities/work/writer-model'

interface WriterCardBodyProps {
    writer: WriterModel
    error?: ZodFormattedError<WriterModel>
}

const WriterCardBody = ({ writer, error }: WriterCardBodyProps) => {
    const { libStore } = React.useContext(StoresContext)

    const writerRole = libStore.writerRoles.find((role: SelectOption) => +role.id === writer.roleCode)?.label

    const fullName = writer.fullName || formatName(writer.firstName, writer.lastName)
    const writerNameError = [...(error?.firstName?._errors || []), ...(error?.lastName?._errors || [])].join(', ')
    const ipiNumberError = error?.ipiNumber?._errors?.join(', ')
    const roleCodeError = error?.roleCode?._errors?.join(', ')

    return (
        <div className="card-row">
            <div data-label="Writer Name">
                <span>{fullName}</span>
                <span className="error-field">{writerNameError}</span>
            </div>
            <div data-label="Writer IPI">
                <span>{tableCellSanitizer(writer.ipiNumber)}</span>
                <span className="error-field">{ipiNumberError}</span>
            </div>
            <div data-label="Writer Role">
                <span>{writerRole}</span>
                <span className="error-field">{roleCodeError}</span>
            </div>
        </div>
    )
}

export default observer(WriterCardBody)
